import axios from 'axios';

import { OpportunitiesData } from 'containers/JoinUsPage/JoinUsPage.types';

const replaceString = (text, stringsToReplace): string => {
  const regExp = new RegExp(Object.keys(stringsToReplace).join('|'), 'g');
  const newString = text.replace(regExp, matched => stringsToReplace[matched]);

  return newString;
};

const removeSuperunionPrefixes = {
  ['Superunion ']: '',
  ['SUPERUNION ']: '',
  [' ,']: ',',
};

export const jobDescriptionSections = (str: string) => {
  const divideTitlesAndContent = [
    str.match(/<h5>.*?<\/h5>/g) || [''],
    str.split(/<h5>.*?<\/h5>/g).filter((item: any) => item !== ''),
  ];

  const descriptionBySections = divideTitlesAndContent[0].map(
    (item, index) => ({
      subtitle: item,
      content: divideTitlesAndContent[1][index],
    })
  );

  return descriptionBySections;
};

export const opportunitiesJobs = async (): Promise<OpportunitiesData> => {
  const jobs = await axios
    .get(
      'https://boards-api.greenhouse.io/v1/boards/designbridge/jobs?content=true'
    )
    .then((response: any) => response.data)
    .then(({ jobs }) => {
      return jobs.sort((a, b) => {
        // @ts-ignore
        return new Date(b.updated_at) - new Date(a.updated_at);
      });
    })
    .then(jobs => {
      return jobs.map(job => ({
        ...job,
        departments: job.departments.map(department =>
          replaceString(department.name, removeSuperunionPrefixes)
        ),
        offices: job.offices.map(office =>
          replaceString(office.name, removeSuperunionPrefixes)
        ),
        date: new Date(job.updated_at),
        content: job.content.replace(/&amp;nbsp;/g, ' '),
      }));
    });

  const departments = jobs
    .reduce((acc, val) => {
      return [...acc, ...val.departments];
    }, [])
    .sort();

  const locations: string = jobs
    .reduce((acc, val) => {
      return [...acc, ...val.offices];
    }, [])
    .sort();

  return {
    opportunities: jobs,
    // @ts-ignore
    departments: [...new Set(departments)],
    // @ts-ignore
    locations: [...new Set(locations)],
  };
};

export const categoryFind = (categoriesArr: Array<any>) =>
  categoriesArr
    .map((item, index) => {
      if (item.type === 'opportunities') return { ...item, index };
      else return false;
    })
    .filter(item => typeof item === 'object')[0];
